import React from 'react'
import { FaTimes } from 'react-icons/fa'
import Logo from '../Components/Images/LogoBase.png'

const HomeSideBar = ({ openMenu, setOpenMenu }) => {
    return (
        <div className={`text-white fixed top-0 left-0 py-5 rounded-b-3xl text-lg w-full h-[340px] bg-[#271D2E] transition-all duration-500 ${openMenu ? 'block' : 'hidden'}`}>
            <div className='flex flex-col gap-10 px-5'>
                <div className='flex justify-between'>
                    <a href="/">
                        <div className='flex gap-2 items-center'>
                            <img src={Logo} alt="" />
                            <p className='sh:text-xl text-base font-medium'>reccur</p>
                        </div>
                    </a>
                    <div className='right-2 flex items-center gap-2 top-2 sh:text-[20px] text-base cursor-pointer' onClick={() => setOpenMenu(!openMenu)}>
                        <p>Menu</p>
                        <FaTimes />
                    </div>
                </div>
                <div className='flex flex-col gap-7 px-7 text-[#D2D0D6] text-[14px] font-medium'>
                    <a href="/use_cases" className=''>
                        <p>Use Case</p>
                    </a>
                    <a href="/how_it_works" className=''>
                        <p>How it works</p>
                    </a>
                    <a href="/about" className=''>
                        <p>About</p>
                    </a>
                    {/* <a href="/support" className=''> */}
                        {/* <p>Support</p> */}
                    {/* </a> */}
                    <div className='flex justify-between w-full'>
                        <a href="/login">
                            <button className='py-2 w-full px-[14px]'>Log in</button>
                        </a>
                        <a href="/signup">
                            <button className='bg-[#531CB3] w-full font-light text-white py-2 px-[14px] rounded-[10px]'>
                                Get started
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeSideBar